import { createFileRoute } from '@tanstack/react-router'
import { OnboardingWizardResume } from '@/components/onboarding/wizard/OnboardingWizardResume'

export const Route = createFileRoute('/onboarding/organization/')({
  component: OnboardingWizardResume,
})
